import React from 'react';
import HomeFloorBox from './home-floor-box';
import MoreBtn from './home-floor-more-btn';
import SattaCard from './satta-card';
import {MatkaListItem} from '@/pages/home/home.type';

interface HomeFloorSattaProps {
  name: string;
  id: string;
  shown?: boolean;
  categoryPic?: string;
  matkaList: MatkaListItem[];
}

const HomeFloorSatta = ({
  name,
  id,
  categoryPic,
  matkaList,
  shown = true,
}: HomeFloorSattaProps) => {
  const [more, setMore] = React.useState(false);

  return (
    <HomeFloorBox
      shown={shown}
      gameType={'satta'}
      id={id}
      name={name}
      rightNode={<MoreBtn expend={more} onClick={() => setMore(!more)} />}
      categoryPic={categoryPic}>
      <>
        {(more ? matkaList : matkaList.slice(0, 9)).map((item, _i) => (
          <SattaCard i={_i} key={_i} v={item} />
        ))}
      </>
    </HomeFloorBox>
  );
};

export default HomeFloorSatta;
